/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { LootBoxInstanceSource } from './LootBoxInstanceSource';
import {
    LootBoxInstanceSourceFromJSON,
    LootBoxInstanceSourceFromJSONTyped,
    LootBoxInstanceSourceToJSON,
    LootBoxInstanceSourceToJSONTyped,
} from './LootBoxInstanceSource';

/**
 * 
 * @export
 * @interface LootBoxInstanceResponse
 */
export interface LootBoxInstanceResponse {
    /**
     * 
     * @type {string}
     * @memberof LootBoxInstanceResponse
     */
    id: string;
    /**
     * 
     * @type {number}
     * @memberof LootBoxInstanceResponse
     */
    createdAt: number;
    /**
     * 
     * @type {number}
     * @memberof LootBoxInstanceResponse
     */
    updatedAt: number;
    /**
     * 
     * @type {string}
     * @memberof LootBoxInstanceResponse
     */
    user: string;
    /**
     * 
     * @type {string}
     * @memberof LootBoxInstanceResponse
     */
    lootBoxConfig: string;
    /**
     * The LootBoxPrizePoolVersion this box is stamped to. The open draws from THIS version's frozen stock and odds — the pool the box was sold under.
     * @type {string}
     * @memberof LootBoxInstanceResponse
     */
    poolVersionId?: string;
    /**
     * 
     * @type {LootBoxInstanceSource}
     * @memberof LootBoxInstanceResponse
     */
    source: LootBoxInstanceSource;
    /**
     * 
     * @type {string}
     * @memberof LootBoxInstanceResponse
     */
    sourceRef?: string;
    /**
     * 
     * @type {Date}
     * @memberof LootBoxInstanceResponse
     */
    openedAt?: Date;
    /**
     * ObjectId of the LootBoxPrize subdocument that was won
     * @type {string}
     * @memberof LootBoxInstanceResponse
     */
    prizeWonId?: string;
    /**
     * 
     * @type {string}
     * @memberof LootBoxInstanceResponse
     */
    promoCode?: string;
    /**
     * 
     * @type {string}
     * @memberof LootBoxInstanceResponse
     */
    purchaseRef?: string;
}



/**
 * Check if a given object implements the LootBoxInstanceResponse interface.
 */
export function instanceOfLootBoxInstanceResponse(value: object): value is LootBoxInstanceResponse {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    if (!('user' in value) || value['user'] === undefined) return false;
    if (!('lootBoxConfig' in value) || value['lootBoxConfig'] === undefined) return false;
    if (!('source' in value) || value['source'] === undefined) return false;
    return true;
}

export function LootBoxInstanceResponseFromJSON(json: any): LootBoxInstanceResponse {
    return LootBoxInstanceResponseFromJSONTyped(json, false);
}

export function LootBoxInstanceResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): LootBoxInstanceResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'createdAt': json['createdAt'],
        'updatedAt': json['updatedAt'],
        'user': json['user'],
        'lootBoxConfig': json['lootBoxConfig'],
        'poolVersionId': json['poolVersionId'] == null ? undefined : json['poolVersionId'],
        'source': LootBoxInstanceSourceFromJSON(json['source']),
        'sourceRef': json['sourceRef'] == null ? undefined : json['sourceRef'],
        'openedAt': json['openedAt'] == null ? undefined : (new Date(json['openedAt'])),
        'prizeWonId': json['prizeWonId'] == null ? undefined : json['prizeWonId'],
        'promoCode': json['promoCode'] == null ? undefined : json['promoCode'],
        'purchaseRef': json['purchaseRef'] == null ? undefined : json['purchaseRef'],
    };
}

export function LootBoxInstanceResponseToJSON(json: any): LootBoxInstanceResponse {
    return LootBoxInstanceResponseToJSONTyped(json, false);
}

export function LootBoxInstanceResponseToJSONTyped(value?: LootBoxInstanceResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'createdAt': value['createdAt'],
        'updatedAt': value['updatedAt'],
        'user': value['user'],
        'lootBoxConfig': value['lootBoxConfig'],
        'poolVersionId': value['poolVersionId'],
        'source': LootBoxInstanceSourceToJSON(value['source']),
        'sourceRef': value['sourceRef'],
        'openedAt': value['openedAt'] == null ? undefined : ((value['openedAt']).toISOString()),
        'prizeWonId': value['prizeWonId'],
        'promoCode': value['promoCode'],
        'purchaseRef': value['purchaseRef'],
    };
}

